import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import { FormBox, InputBox } from "../../../../../components/AntdAddons";
import dayjs from "dayjs";
import { dateFormats } from "../../utils/constants";
import { rules } from "./rules";
import { CUSTOMER_ROLE, INDUSTRY_FILTER } from "../../../../../config/Constant";
import { fetchList as fetchCompanyList } from "../../../Company/utils/slice";
import { fetchCareercategory } from "../../../../../store/CommonSlice";
import { customerAccessIndustryList } from "../../utils/slice";
import { useAppDispatch } from "../../../../../utils/hooks/hooks";
import { RootState } from "../../../../../store/app";

// import { dateCompare } from "../../../../../config/Global";
import { useDispatch, useSelector } from "react-redux";
import { fetchIndustryWizeData } from "../../../Industry/utils/slice";
import React from "react";


/**
 * Renders a form component for adding or editing a record in the Cms module.
 *
 * @param {object} props - The component props.
 * @param {object} props.form - The form instance.
 * @param {string} props.id - The form ID.
 * @param {function} props.handleSubmit - The function to handle form submission.
 * @param {function} props.onValuesChange - The function to handle form value changes and update the form fields.
 * @param {object} props.editValues - The values to edit in the form fields, if value already exists.
 * @return {JSX.Element} The rendered form component.
 */
const FormComponent: React.FC<any> = ({
    form,
    id,
    handleSubmit,
    onValuesChange,
    editValues,
}) => {


    const {
        start_date,
        end_date,
    } = editValues ?? {};


    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [companyList, setCompanyList] = useState<any>([]);
    const [carierCategoryList, setCarierCategoryList] = useState<any>([]);
    const [startDate, setStartDate] = useState<any>(null);
    const [endDate, setEndDate] = useState<any>(null);
    const [isCustomer, setIsCustomer] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    const userDetail = useSelector((state: RootState) => state.auth.userDetail);
    const [isSpecial, setIsSpecial] = useState<boolean>(false);
    const [industryList, setIndustryList] = useState<any>([]);

    const minDate = dayjs().subtract(1, 'day');
    const disableDate = (current: any, type = "start", date: any = null) => {
        if (current < minDate) {
            return true;
        }
        if (date == null) {
            return false;
        }
        return current && (type == "start" ? current > dayjs(date).subtract(1, 'day') : current < dayjs(date).add(1, 'day'));
    };



    const onCustomerChange = (val: any, isEdit = false) => {
        dispatch(customerAccessIndustryList(val))
            .then((data: any) => {
                setIndustryList(data.rows);
                !isEdit && form.setFieldValue('industry_id', null);
            }).catch((error: any) => error);
    }

    const onIndustryChange = (id: any, resetVal = true) => {



        if (id) {

            if (resetVal) {
                form.setFieldsValue({
                    category_id: null,
                });

                // form.setFieldsValue({
                //   ["mapping"]: [],
                // });


            }
            dispatch(fetchIndustryWizeData([id], [
                INDUSTRY_FILTER.CAREER_CATEGORY,
            ]))
                .then((response: any) => {
                    setCarierCategoryList(response.data.career_category)
                })
                .catch((error: any) => error);
        }
    }

    useEffect(() => {
        setIsCustomer(false);
        if (userDetail.role_id == CUSTOMER_ROLE) {
            setIsCustomer(true);
            form.setFieldValue('company_id', userDetail.company.company_name);
            // form.setFieldValue('access_code', userDetail.access_codes[0].access_code);
            // form.setFieldValue('access_code', userDetail.access_codes[0].access_code);
        }
        else {
            dispatch(fetchCompanyList())
                .then((data: any) => {
                    var companysorted = [...data.rows];
                    companysorted = companysorted.sort((a: any, b: any) => {
                        var nameA = a.company_name.toLowerCase(), nameB = b.company_name.toLowerCase();
                        if (nameA < nameB) //sort string ascending
                            return -1;
                        if (nameA > nameB)
                            return 1;
                        return 0; //default return value (no sorting)
                    });
                    setCompanyList(companysorted);

                })
                .catch((error: any) => error);
        }


    }, [userDetail]);






    useEffect(() => {
        setIsEdit(false);
        if (editValues) {
            const industry_id = editValues?.industry.length > 0 ? editValues.industry[0].id : null;
            onCustomerChange(editValues.company_id, true)
            onIndustryChange(editValues.industry_id, true)
            // form.setFieldsValue({...editValues,...{industry_id:industry_id}});
            // form.setFieldsValue(editValues);
            form.setFieldsValue({
                ...editValues,
                industry_id: industry_id,
                start_date: start_date && dayjs(start_date),
                end_date: end_date && dayjs(end_date),
                category_id: editValues?.categories && editValues.categories.length > 0 ? editValues.categories.map((item: any) => item.id) : [],
                access_code: editValues.access_codes && editValues.access_codes.length > 0 ? editValues.access_codes[0].access_code : ""
            });
            setIsSpecial(editValues.special_flag == '1' ? true : false);
            setIsEdit(true);
        }
        else {
            form.setFieldValue('special_flag', 2);
        }

    }, [editValues, form]);

    /**
     * Process the form data and handle the form submission.  
     */
    const onFinish = (data: any) => {
        if (isCustomer) {
            data.company_id = userDetail.company_id
        }
        data.start_date = data.start_date && dayjs(data.start_date).format(dateFormats.start_date_api);
        data.end_date = data.end_date && dayjs(data.end_date).format(dateFormats.end_date_api);
        handleSubmit(data);
    };
    return (
        <>
            <FormBox
                form={form}
                id={id}
                onFinish={onFinish}
                onValuesChange={onValuesChange}
            >
                <Row gutter={15}>
                    <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 6 }}>
                        <InputBox.Text required name="campaign_name" label="Subscription Name" />
                    </Col>


                    <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 6 }}>
                        <InputBox.Select
                            required
                            label="Customer"
                            name="company_id"
                            showSearch
                            className="singleSelect"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                                0
                            }
                            options={{
                                list: companyList,
                                valueKey: "id",
                                textKey: "company_name",
                                // disabled:true
                            }}
                            onChange={(val) => onCustomerChange(val)}
                            // defaultValue={9}

                            disabled={isCustomer || isEdit}
                        />
                    </Col>

                    <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 6 }}>
                        <InputBox.Select
                            required
                            label="Industry"
                            name="industry_id"
                            showSearch
                            className="singleSelect"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                                0
                            }
                            onChange={(val) => onIndustryChange(val)}

                            options={{
                                list: industryList,
                                valueKey: "id",
                                textKey: "industry_name",
                            }}
                            disabled={isCustomer || isEdit}
                        />
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 6 }}>
                        <InputBox.Number
                            maxLength={4}
                            name="access_code_count"
                            rules={rules.accessCodeCount()}
                            minValue={1}
                            min={1}
                            max={9999}
                            maxValue={9999}
                            label="Total Access Codes"
                            disabled={isEdit}
                        />

                    </Col>



                </Row>
                <Row gutter={15}>

                    <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 12 }}>
                        <InputBox.DatePicker
                            required
                            label="Start Date"
                            name="start_date"
                            format={dateFormats.start_date}
                            rules={rules.startDate()}
                            onChange={(date) => setStartDate(date)}
                            disabledDate={(date) => disableDate(date, 'start', endDate)}
                            disabled={editValues && dayjs(editValues.start_date) < minDate}
                            defaultPickerValue={minDate}

                        />

                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 12 }}>
                        <InputBox.DatePicker
                            required
                            label="End Date"
                            name="end_date"
                            format={dateFormats.end_date}
                            rules={rules.endDate()}
                            onChange={(date) => setEndDate(date)}
                            disabledDate={(date) => disableDate(date, 'end', startDate)}
                            disabled={editValues && dayjs(editValues.end_date) < minDate}
                            defaultPickerValue={minDate}
                        />
                    </Col>


                </Row>
                <Row gutter={15}>
                    <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 8 }}>
                        <InputBox.Select
                            mode="multiple"
                            required
                            label="Career Categories"
                            name="category_id"
                            showSearch
                            className="multiSelect"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                                0
                            }
                            options={{
                                // list: carierCategoryList,
                                list: carierCategoryList.map((item:any)=>{
                                    const obj = {...item};
                                    obj.name= `${item.code} - ${item.name}`;
                                    return obj;}),
                                valueKey: "id",
                                textKey: "name",
                                // disabled:true
                            }}
                            // defaultValue={9}

                            disabled={isCustomer || isEdit}
                        />
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 8 }}>
                        <InputBox.Select
                            required
                            label="Access Code Type"
                            name="special_flag"
                            className="singleSelect"
                            optionFilterProp="children"
                            // defaultValue="2"

                            allowClear
                            options={{
                                list: [{ key: 'Regular', value: 2 }, { key: 'Internal', value: 1 }],
                                valueKey: "value",
                                textKey: "key",
                            }}
                            onChange={(value) => {
                                setIsSpecial(value == '1' ? true : false);
                            }}
                            disabled={isCustomer || isEdit}
                        />
                    </Col>
                    {isSpecial ?
                        <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 8 }}  >
                            <InputBox.Text
                                required
                                name="access_code"
                                label="Custom Access Code"
                                rules={rules.access_code()}
                                disabled={isCustomer || isEdit}
                            />
                        </Col>
                        : <>
                            <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 8 }}>
                                <InputBox.Text
                                    rules={!isEdit ? rules.companyInitials() :null}
                                    maxLength={5}
                                    name="short_code"
                                    label="Subscription Unique Code"
                                    disabled={isEdit}
                                />
                            </Col>



                        </>}

                         <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 24 }}>
                        <InputBox.TextArea name="description" label="Description" />
                    </Col>


                </Row>

            </FormBox>
        </>
    );
};

export default FormComponent;
